import { render, staticRenderFns } from "./Gcoin.vue?vue&type=template&id=a657ded8&scoped=true&"
import script from "./Gcoin.vue?vue&type=script&lang=js&"
export * from "./Gcoin.vue?vue&type=script&lang=js&"
import style0 from "./Gcoin.vue?vue&type=style&index=0&id=a657ded8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a657ded8",
  null
  
)

export default component.exports